// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function service_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicle_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
  if (vehicle_id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var icon_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon_url"), null));
      if (icon_url.TAG === /* Ok */0) {
        var service_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
        if (service_type.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    vehicle_id: vehicle_id._0,
                    name: name._0,
                    icon_url: icon_url._0,
                    service_type: service_type._0
                  }
                };
        }
        var e = service_type._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".service_type" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = icon_url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".icon_url" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = vehicle_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle_id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function location_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lat = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lat"), null));
  if (lat.TAG === /* Ok */0) {
    var $$long = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "long"), null));
    if ($$long.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                lat: lat._0,
                long: $$long._0
              }
            };
    }
    var e = $$long._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".long" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = lat._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lat" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function saved_address_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "uuid"), null));
    if (uuid.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                uuid: uuid._0
              }
            };
    }
    var e = uuid._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".uuid" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function place_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var doorstep_address = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "doorstep_address"), null));
  if (doorstep_address.TAG === /* Ok */0) {
    var saved_address = Decco.optionFromJson(saved_address_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "saved_address"), null));
    if (saved_address.TAG === /* Ok */0) {
      var address = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "address"), null));
      if (address.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  doorstep_address: doorstep_address._0,
                  saved_address: saved_address._0,
                  address: address._0
                }
              };
      }
      var e = address._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".address" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = saved_address._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".saved_address" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = doorstep_address._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".doorstep_address" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function contact_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "number"), null));
    if (number.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                number: number._0
              }
            };
    }
    var e = number._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".number" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function route_address_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var $$location = location_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
  if ($$location.TAG === /* Ok */0) {
    var place = place_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "place"), null));
    if (place.TAG === /* Ok */0) {
      var contact = Decco.optionFromJson(contact_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contact"), null));
      if (contact.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  location: $$location._0,
                  place: place._0,
                  contact: contact._0
                }
              };
      }
      var e = contact._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".contact" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = place._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".place" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = $$location._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".location" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function waypoint_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var count = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "count"), null));
  if (count.TAG === /* Ok */0) {
    var waypoints = Decco.arrayFromJson(route_address_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waypoints"), null));
    if (waypoints.TAG === /* Ok */0) {
      var restriction = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "restriction"), null));
      if (restriction.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  count: count._0,
                  waypoints: waypoints._0,
                  restriction: restriction._0
                }
              };
      }
      var e = restriction._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".restriction" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = waypoints._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waypoints" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = count._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".count" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function route_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var source = Decco.optionFromJson(route_address_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "source"), null));
  if (source.TAG === /* Ok */0) {
    var destination = Decco.optionFromJson(route_address_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
    if (destination.TAG === /* Ok */0) {
      var waypoint_info = waypoint_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waypoint_info"), null));
      if (waypoint_info.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  source: source._0,
                  destination: destination._0,
                  waypoint_info: waypoint_info._0
                }
              };
      }
      var e = waypoint_info._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".waypoint_info" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = destination._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".destination" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = source._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".source" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function total_amount_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var currency = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency"), null));
  if (currency.TAG === /* Ok */0) {
    var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
    if (amount.TAG === /* Ok */0) {
      var cash_payable = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cash_payable"), null));
      if (cash_payable.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  currency: currency._0,
                  amount: amount._0,
                  cash_payable: cash_payable._0
                }
              };
      }
      var e = cash_payable._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".cash_payable" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".amount" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = currency._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".currency" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function orders_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_crn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_crn"), null));
  if (order_crn.TAG === /* Ok */0) {
    var geo_region_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
    if (geo_region_id.TAG === /* Ok */0) {
      var order_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_status"), null));
      if (order_status.TAG === /* Ok */0) {
        var order_created_at = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_created_at"), null));
        if (order_created_at.TAG === /* Ok */0) {
          var _type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
          if (_type.TAG === /* Ok */0) {
            var service_details = Decco.optionFromJson(service_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_details"), null));
            if (service_details.TAG === /* Ok */0) {
              var vas_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vas_type"), null));
              if (vas_type.TAG === /* Ok */0) {
                var is_business_customer = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_business_customer"), null));
                if (is_business_customer.TAG === /* Ok */0) {
                  var route_details = route_details_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "route_details"), null));
                  if (route_details.TAG === /* Ok */0) {
                    var total_amount = Decco.optionFromJson(total_amount_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_amount"), null));
                    if (total_amount.TAG === /* Ok */0) {
                      var tracking_link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tracking_link"), null));
                      if (tracking_link.TAG === /* Ok */0) {
                        var payment_mode = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "payment_mode"), null));
                        if (payment_mode.TAG === /* Ok */0) {
                          var pay_online_enabled = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pay_online_enabled"), null));
                          if (pay_online_enabled.TAG === /* Ok */0) {
                            var rebooking_enabled = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rebooking_enabled"), null));
                            if (rebooking_enabled.TAG === /* Ok */0) {
                              var muneemji_enabled = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "muneemji_enabled"), null));
                              if (muneemji_enabled.TAG === /* Ok */0) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: {
                                          order_crn: order_crn._0,
                                          geo_region_id: geo_region_id._0,
                                          order_status: order_status._0,
                                          order_created_at: order_created_at._0,
                                          _type: _type._0,
                                          service_details: service_details._0,
                                          vas_type: vas_type._0,
                                          is_business_customer: is_business_customer._0,
                                          route_details: route_details._0,
                                          total_amount: total_amount._0,
                                          tracking_link: tracking_link._0,
                                          payment_mode: payment_mode._0,
                                          pay_online_enabled: pay_online_enabled._0,
                                          rebooking_enabled: rebooking_enabled._0,
                                          muneemji_enabled: muneemji_enabled._0
                                        }
                                      };
                              }
                              var e = muneemji_enabled._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".muneemji_enabled" + e.path,
                                        message: e.message,
                                        value: e.value
                                      }
                                    };
                            }
                            var e$1 = rebooking_enabled._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".rebooking_enabled" + e$1.path,
                                      message: e$1.message,
                                      value: e$1.value
                                    }
                                  };
                          }
                          var e$2 = pay_online_enabled._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".pay_online_enabled" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                  }
                                };
                        }
                        var e$3 = payment_mode._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".payment_mode" + e$3.path,
                                  message: e$3.message,
                                  value: e$3.value
                                }
                              };
                      }
                      var e$4 = tracking_link._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".tracking_link" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                              }
                            };
                    }
                    var e$5 = total_amount._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".total_amount" + e$5.path,
                              message: e$5.message,
                              value: e$5.value
                            }
                          };
                  }
                  var e$6 = route_details._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".route_details" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                          }
                        };
                }
                var e$7 = is_business_customer._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".is_business_customer" + e$7.path,
                          message: e$7.message,
                          value: e$7.value
                        }
                      };
              }
              var e$8 = vas_type._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".vas_type" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                      }
                    };
            }
            var e$9 = service_details._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".service_details" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = _type._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "." + ("type" + e$10.path),
                    message: e$10.message,
                    value: e$10.value
                  }
                };
        }
        var e$11 = order_created_at._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".order_created_at" + e$11.path,
                  message: e$11.message,
                  value: e$11.value
                }
              };
      }
      var e$12 = order_status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".order_status" + e$12.path,
                message: e$12.message,
                value: e$12.value
              }
            };
    }
    var e$13 = geo_region_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".geo_region_id" + e$13.path,
              message: e$13.message,
              value: e$13.value
            }
          };
  }
  var e$14 = order_crn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_crn" + e$14.path,
            message: e$14.message,
            value: e$14.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var limit = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "limit"), null));
  if (limit.TAG === /* Ok */0) {
    var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
    if (offset.TAG === /* Ok */0) {
      var live_orders = Decco.arrayFromJson(orders_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "live_orders"), null));
      if (live_orders.TAG === /* Ok */0) {
        var past_orders = Decco.arrayFromJson(orders_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "past_orders"), null));
        if (past_orders.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    limit: limit._0,
                    offset: offset._0,
                    live_orders: live_orders._0,
                    past_orders: past_orders._0
                  }
                };
        }
        var e = past_orders._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".past_orders" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = live_orders._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".live_orders" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = offset._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".offset" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = limit._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".limit" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

export {
  service_details_decode ,
  location_decode ,
  saved_address_decode ,
  place_decode ,
  contact_decode ,
  route_address_details_decode ,
  waypoint_info_decode ,
  route_details_decode ,
  total_amount_decode ,
  orders_decode ,
  t_decode ,
}
/* No side effect */
